document.addEventListener('DOMContentLoaded', function () {
  const themeVariables = window.themeVariables || {};
  const customerTags = themeVariables.customer?.tags || [];
  const settings = themeVariables.settings || {};
  const ordersTexts = themeVariables.orders || {};
  const locale = window.Shopify?.locale || 'en-US';

  // Récup SUB: xxx dans les tags client
  const customerSub =
    customerTags
      .find(tag => tag.startsWith('SUB:'))
      ?.replace('SUB:', '')
      ?.trim() || null;

  if (!customerSub) {
    showError();
    return;
  }

  const apiDomain = settings.externalOrderApiDomain;
  if (!apiDomain) {
    showError();
    return;
  }

  const API_BASE_URL = `${apiDomain.replace(/\/$/, '')}/shopify/purchases/${customerSub}`;

  /* -----------------------
   * Helpers génériques
   * --------------------- */

  function getPurchaseIdFromUrl() {
    const pathParts = window.location.pathname.split('/');
    return pathParts[pathParts.length - 1];
  }

  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';

    const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true };

    const datePart = date.toLocaleDateString(locale, dateOptions);
    const timePart = date.toLocaleTimeString(locale, timeOptions);

    return `${datePart} at ${timePart}`;
  }

  function formatMoney(amount, currency) {
    if (amount === undefined || amount === null) return '';
    const symbol = currency === 'EUR' ? '€' : currency;
    return `${Number(amount).toFixed(2)} ${symbol}`;
  }

  /* -----------------------
   * Transformation des données
   * --------------------- */

  function transformRecord(apiResponse) {
    const purchase = apiResponse.purchase || {};
    const t = purchase.transaction || {};
    const saleItems = (t.sale_items || []).map((it, idx) => {
      const shopifyData = it.shopify || {};
      const productUrl = shopifyData.product_handle
        ? `/products/${shopifyData.product_handle}`
        : null;

      return {
        id: it.item_id || String(idx + 1),
        title:
          shopifyData.product_title ||
          (it.item_id
            ? `${ordersTexts.product || 'Article'} ${it.item_id}`
            : 'Article'),
        variant_title: shopifyData.variant_title?.toUpperCase() || '',
        quantity: it.quantity || 0,
        price: it.unit_price || 0,
        total: it.amount || (it.unit_price || 0) * (it.quantity || 0),
        image: shopifyData.image_url,
        image_alt: shopifyData.image_alt || shopifyData.product_title,
        brand: shopifyData.brand || '',
        product_url: productUrl,
        is_returned: !!it.is_returned
      };
    });

    const tax = t.tax_amount || 0;
    const total = t.amount || 0;
    const subtotal = t.net_amount || total - tax;

    return {
      id: purchase.id || apiResponse.purchase_id,
      name: '#' + (t.transaction_id || purchase.id || apiResponse.purchase_id),
      display_name: null,
      created_at: t.transaction_date_time_iso || t.transaction_date_time,
      total,
      subtotal,
      shipping: 0,
      tax,
      currency: t.currency,
      line_items: saleItems,
      store_name: t.business_unit_name || '',
      tracking_number: null,
      tracking_url: null
    };
  }

  /* -----------------------
   * DOM helpers
   * --------------------- */

  function createImageBlock(item) {
    const wrapper = document.createElement('div');
    wrapper.className = 'line-item__image-wrapper';

    const fallbackDiv = document.createElement('div');
    fallbackDiv.className = 'line-item__image-fallback';
    fallbackDiv.style.cssText =
      'width:80px;height:80px;background-color:#e5e5e5;display:flex;align-items:center;justify-content:center;color:#999;font-size:12px;text-align:center;';
    fallbackDiv.innerHTML = '<span>No<br>Image</span>';

    if (!item.image) {
      wrapper.appendChild(fallbackDiv);
      return wrapper;
    }

    const img = document.createElement('img');
    img.className = 'line-item__image';
    img.loading = 'lazy';
    img.width = 80;
    img.height = 80;
    img.style.cssText = 'width:80px;height:80px;object-fit:cover;';
    img.alt = item.image_alt || 'Product image';

    let imageLoaded = false;
    const timeoutId = setTimeout(() => {
      if (!imageLoaded) {
        wrapper.innerHTML = '';
        wrapper.appendChild(fallbackDiv);
      }
    }, 3000);

    img.onload = function () {
      imageLoaded = true;
      clearTimeout(timeoutId);
    };

    img.onerror = function () {
      imageLoaded = true;
      clearTimeout(timeoutId);
      wrapper.innerHTML = '';
      wrapper.appendChild(fallbackDiv);
    };

    wrapper.appendChild(img);
    img.src = item.image;

    return wrapper;
  }

  function renderLineItems(lineItems, currency) {
    const tbody = document.getElementById('line-items');
    if (!tbody) return;

    tbody.innerHTML = '';

    lineItems.forEach(item => {
      const tr = document.createElement('tr');
      tr.className = 'line-item';

      // --- Colonne produit ---
      const productCell = document.createElement('td');
      productCell.className = 'line-item__product';

      const contentWrapper = document.createElement('div');
      contentWrapper.className = 'line-item__content-wrapper';

      // Image (+ lien éventuel)
      const imageBlock = createImageBlock(item);

      if (item.product_url) {
        const imageLink = document.createElement('a');
        imageLink.href = item.product_url;
        imageLink.className = 'line-item__image-wrapper';

        // On déplace le contenu de imageBlock dans le lien
        while (imageBlock.firstChild) {
          imageLink.appendChild(imageBlock.firstChild);
        }

        contentWrapper.appendChild(imageLink);
      } else {
        contentWrapper.appendChild(imageBlock);
      }

      // Infos produit
      const infoDiv = document.createElement('div');
      infoDiv.className = 'line-item__info';

      if (item.brand) {
        const brandDiv = document.createElement('div');
        brandDiv.className =
          'product-item-meta__brand heading heading--xxsmall text--subdued';
        brandDiv.textContent = item.brand;
        infoDiv.appendChild(brandDiv);
      }

      const titleElement = document.createElement(
        item.product_url ? 'a' : 'h3'
      );
      titleElement.className =
        'product-item-meta__title heading heading--small';
      if (item.product_url) {
        titleElement.href = item.product_url;
      }
      titleElement.textContent = item.title;
      infoDiv.appendChild(titleElement);

      if (item.variant_title) {
        const variantDiv = document.createElement('div');
        variantDiv.className = 'product-item-meta__variant text--subdued';
        variantDiv.textContent = item.variant_title;
        infoDiv.appendChild(variantDiv);
      }

      if (item.is_returned) {
        const refundDiv = document.createElement('div');
        refundDiv.className = 'line-item__refund-status';
        refundDiv.innerHTML = '<span class="refund-badge">Remboursé</span>';
        infoDiv.appendChild(refundDiv);
      }

      // Prix mobile
      const mobilePriceDiv = document.createElement('div');
      mobilePriceDiv.className =
        'price-list price-list--stack hidden-tablet-and-up';
      const priceSpan = document.createElement('span');
      priceSpan.className = 'price';
      priceSpan.innerHTML = `<span class="visually-hidden">Prix de vente</span>${formatMoney(
        item.price,
        currency
      )}`;
      mobilePriceDiv.appendChild(priceSpan);
      infoDiv.appendChild(mobilePriceDiv);

      // Quantité mobile
      const mobileQuantityDiv = document.createElement('div');
      mobileQuantityDiv.className =
        'line-item__quantity hidden-tablet-and-up text--xsmall';
      mobileQuantityDiv.textContent = `Quantité: ${item.quantity}`;
      infoDiv.appendChild(mobileQuantityDiv);

      contentWrapper.appendChild(infoDiv);
      productCell.appendChild(contentWrapper);
      tr.appendChild(productCell);

      // --- Colonne quantité (desktop) ---
      const quantityCell = document.createElement('td');
      quantityCell.className = 'line-item__quantity text--center hidden-phone';
      const quantityDiv = document.createElement('div');
      quantityDiv.style.lineHeight = '1.5';
      quantityDiv.textContent = item.quantity;
      quantityCell.appendChild(quantityDiv);
      tr.appendChild(quantityCell);

      // --- Colonne prix total (desktop) ---
      const priceCell = document.createElement('td');
      priceCell.className =
        'line-item__price-list-container text--right hidden-phone';

      const priceListDiv = document.createElement('div');
      priceListDiv.className = 'price-list price-list--stack';

      const totalPriceSpan = document.createElement('span');
      totalPriceSpan.className = 'price';
      totalPriceSpan.innerHTML = `<span class="visually-hidden">Prix de vente</span>${formatMoney(
        item.total,
        currency
      )}`;

      priceListDiv.appendChild(totalPriceSpan);
      priceCell.appendChild(priceListDiv);
      tr.appendChild(priceCell);

      tbody.appendChild(tr);
    });
  }

  /* -----------------------
   * États & erreurs
   * --------------------- */

  function hideLoading() {
    const loadingEl = document.getElementById('order-loading');
    if (loadingEl) loadingEl.style.display = 'none';
  }

  function showOrderContent() {
    hideLoading();
    const contentEl = document.getElementById('order-content');
    if (contentEl) contentEl.style.display = 'block';
  }

  function showError() {
    hideLoading();
    const container = document.getElementById('error-container');
    if (container) {
      container.style.display = 'block';
      const messageEl = document.getElementById('error-message');
      if (messageEl) {
        messageEl.textContent =
          ordersTexts.loadingError || 'Une erreur est survenue.';
      }
    }
  }

  /* -----------------------
   * Fetch API (avec fallback)
   * --------------------- */

  async function fetchSinglePurchase(purchaseId) {
    const apiUrl = `${API_BASE_URL}/${purchaseId}`;

    // Première tentative avec options complètes
    try {
      const res = await fetch(apiUrl, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'omit',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!res.ok) throw new Error('HTTP ' + res.status);

      const data = await res.json();
      if (!data.success || !data.purchase) {
        throw new Error('Invalid response structure');
      }
      return data;
    } catch (err) {
      // Fallback plus simple
      const res = await fetch(apiUrl);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();
      if (!data.success || !data.purchase) {
        throw new Error('Invalid response structure');
      }
      return data;
    }
  }

  /* -----------------------
   * Chargement de la commande
   * --------------------- */

  async function loadExternalOrder() {
    let paramId = getPurchaseIdFromUrl();
    if (!paramId || paramId === 'external-order') {
      paramId = getUrlParameter('id');
    }

    if (!paramId) {
      showError();
      return;
    }

    let apiResponse;
    try {
      apiResponse = await fetchSinglePurchase(paramId);
    } catch {
      showError();
      return;
    }

    if (!apiResponse || !apiResponse.purchase) {
      showError();
      return;
    }

    const order = transformRecord(apiResponse);

    try {
      // Formatage du numéro d’affichage (pad à 4 chiffres sur le dernier bloc)
      const transactionId = order.name.replace('N°', '').replace('#', '');
      let displayNumber = transactionId;
      const numericMatch = transactionId.match(/(\d+)$/);

      if (numericMatch) {
        const lastNumber = parseInt(numericMatch[1], 10);
        displayNumber = lastNumber.toString().padStart(4, '0');
      }

      order.display_name = 'N°' + displayNumber;

      // Header commande
      const orderNameEl = document.getElementById('order-number');
      const orderDateEl = document.getElementById('order-date');
      const orderStoreEl = document.getElementById('order-store');

      if (orderNameEl) orderNameEl.textContent = order.display_name;
      if (orderDateEl) orderDateEl.textContent = formatDate(order.created_at);
      if (orderStoreEl) {
        orderStoreEl.textContent = order.store_name || 'Magasin Decathlon';
        orderStoreEl.style.display = order.store_name ? 'block' : 'none';
      }

      // Lignes
      renderLineItems(order.line_items, order.currency);

      // Totaux
      const subtotalEl = document.getElementById('subtotal');
      const shippingEl = document.getElementById('shipping');
      const taxEl = document.getElementById('tax');
      const totalEl = document.getElementById('total');

      if (subtotalEl) subtotalEl.textContent = formatMoney(order.subtotal, order.currency);
      if (shippingEl) shippingEl.textContent = formatMoney(order.shipping, order.currency);
      if (taxEl) taxEl.textContent = formatMoney(order.tax, order.currency);
      if (totalEl) totalEl.textContent = formatMoney(order.total, order.currency);

      showOrderContent();
    } catch {
      showError();
    }
  }

  // Petit délai pour laisser le DOM se stabiliser si besoin
  setTimeout(loadExternalOrder, 50);
});
